module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-37.fb6bbcfb.png";